// The app-level status controller owns both socket and polling transitions.
// A page poll must not bypass it with a hard reload.
let controller = null;
let revision = 0;

export function registerQuizStatusController(handler) {
    controller = handler;
    return () => {
        if (controller === handler) controller = null;
    };
}

export function quizStatusRevision() {
    return revision;
}

export function applyQuizStatus(event) {
    revision += 1;
    return controller ? controller(event) : Promise.resolve(false);
}

export function hasQuizStatusController() {
    return controller !== null;
}
